import { deleteCookie } from '@patrianna/shared-utils/cookie'
import {
  CLIENT_COORDINATES,
  USER_ALLOWED_USING_LOCATION,
} from '@patrianna-ui-features/location-verification/src/constants'

import { IS_SIGN_UP_SESSION, removeDataFromLocalStorage } from './localStorage'

export function clearAuthCookies() {
  deleteCookie('LOGGED_IN')
  deleteCookie(CLIENT_COORDINATES, '/')
  deleteCookie(USER_ALLOWED_USING_LOCATION, '/')
  removeDataFromLocalStorage(IS_SIGN_UP_SESSION, false)
}
